import {modal, rootStore} from '@/store/types'
import {Module} from 'vuex'
import {mutations} from './mutations'
import {getters} from './getters'


const state: modal = {
    modalType: 0,
    modalHeaderMessage: 'Header Message',
    modalMessage: 'modalContent',
    modalFooterMessage: 'Loading',
    show: false,
    authModalShow: false,
    servicesModalShow: false,
    smallModalMessageVisibility: false,
    smallModalMessageTitle: '',
    smallModalMessageMessage: ''
}

export const modalState: Module<modal, rootStore> = {
    state,
    getters,
    mutations,
    namespaced: true
}